import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import routes from '../routes';
import { ViolationsPage } from './Violations';
import { ViolationDetailPage } from './ViolationDetail';
import { AppealsPage } from './Appeals';
import { SuspensionsPage } from './Suspensions';
import { StatsPage } from './Stats';
import { ViolationApproversPage } from './ViolationApprovers';

const TasksRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<Navigate to={routes.tasksViolations} replace />} />
      <Route path={routes.tasksViolations} element={<ViolationsPage />} />
      <Route
        path={routes.tasksViolationDetail}
        element={<ViolationDetailPage />}
      />
      <Route path={routes.tasksAppeals} element={<AppealsPage />} />
      <Route path={routes.tasksSuspensions} element={<SuspensionsPage />} />
      <Route path={routes.tasksStats} element={<StatsPage />} />
      <Route
        path={routes.tasksViolationApprovers}
        element={<ViolationApproversPage />}
      />
    </Routes>
  );
};

export default TasksRoutes;
